import React from "react";

const bulkDealsData = [
  {
    title: "Special Rates for Bulk Orders",
    description: "Apartments, builders, interior designers",
  },
  {
    title: "Festive & Seasonal Bulk Discounts",
    description: "",
  },
  {
    title: "Ready Stock + Customization Options",
    description: "",
  },
];

const BulkDealCard = ({ title, description }) => {
  return (
    <div className="card h-100 border-0 rounded-4 shadow-sm bulk-card">
      <div className="card-body text-center p-4">
        <h5 className="card-title fw-bold mb-3">{title}</h5>
        {description && <p className="card-text text-muted">{description}</p>}
      </div>
    </div>
  );
};

const BulkDealsSection = () => {
  return (
    <section className="py-5">
      <div className="container">
        <h2 className="text-center mb-5 fw-bold fs-1">Bulk Deals</h2>
        <div className="row g-4 mb-5">
          {bulkDealsData.map((item, index) => (
            <div key={index} className="col-12 col-md-4">
              <BulkDealCard title={item.title} description={item.description} />
            </div>
          ))}
        </div>
        <div className="text-center">
          <button className="btn btn-lg fw-bold text-white px-5 py-3" style={{backgroundColor:"#02132f"}}>
            Request Bulk Quote
          </button>
        </div>
      </div>

      <style jsx>{`
        .bulk-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          cursor: pointer;
          background: white;
        }
        .bulk-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
        }
        .btn-gradient {
          background: linear-gradient(90deg, #f6d365, #fda085);
          border: none;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .btn-gradient:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </section>
  );
};

export default BulkDealsSection;
